export default {
    'superAdmin': {
        role: 'superAdmin',
        authority: "superAdmin",
        categories: ["Breakdowns", "Functional"],
        userEmail: "developer@procheck.pk",
    },
    'admin': {
        role: 'admin',
        capabilities: [
            'view-all',
            'end-shift',
            'create-dynamicAdjustments-rework',
            'product-write-access',
            'edit-line-settings',
            'update-downtimeLog',
            'audit-trail-access',
            'create-dynamicAdjustments-add-rejections',
        ],
        readOnly: true,
    },
    'operator': {
        role: 'operator',
        capabilities: [
            'view-home',
            'view-observer',
            'create-dynamicAdjustments-rework',
            'create-dynamicAdjustments-add-rejections',
        ],
        readOnly: true,
    },
    'lineLeader': {
        role: 'lineLeader',
        capabilities: [
            'view-all',
            'end-shift',
            'create-dynamicAdjustments-rework',
            'update-downtimeLog',
            'create-dynamicAdjustments-add-rejections',
        ],
        readOnly: true,
    },
    'hallLeader':
    {
        role: 'hallLeader',
        capabilities: [
            'view-all',
            'end-shift',
            'create-dynamicAdjustments-rework',
            'create-dynamicAdjustments-add-rejections',
        ],
        readOnly: true,
    },
    'plantLeader': {
        role: 'plantLeader',
        capabilities: [
            'view-all',
            'end-shift',
            'create-dynamicAdjustments-rework',
            'create-dynamicAdjustments-add-rejections',
        ],
        readOnly: true,
    },
}
